import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Script } from 'gatsby';
import { setSessionStorage } from '../../utilities/functions';

export const HatchChat = () => {
	const [hatchId, setHatchId] = useState(null);
	const locations = useSelector((state) => state.locations);

	useEffect(() => {
		if (['754', '716'].includes(locations.showrooms?.[0]?.branch_id) || window.location.href.includes('/locations/ct/norwalk/') || window.location.href.includes('/locations/ny/roslyn-heights/')) {
			setHatchId('00000006');
		} else if (['757', '731', '735'].includes(locations.showrooms?.[0]?.branch_id) || window.location.href.includes('/locations/nc/') || window.location.href.includes('/locations/north-carolina')) {
			setHatchId('00000007');
		} else if (['743'].includes(locations.showrooms?.[0]?.branch_id) || window.location.href.includes('/locations/mi/grand-rapids/')) {
			setHatchId('00000018');
		} else if (['769', '770'].includes(locations.showrooms?.[0]?.branch_id) || window.location.href.includes('/locations/memphis/') || window.location.href.includes('/locations/nashville/')) {
			setHatchId('00000004');
		} else {
			setHatchId(null);
		}
	}, [locations.showrooms]);

	useEffect(() => {
		if (hatchId) {
			setSessionStorage('forceReload', true);
		}
	}, [hatchId]);

	if (!hatchId) return null;

	return (
		<>
			<Script
				id={`hatch-chat-script-${hatchId}`}
				key='ncChat'
			>
				{`
					function _loadHatchScripts(t){try{var e=document,n=e.createElement("script");n.src=t,n.async=!0,n.defer=!0,n.dataset.hatchid="${hatchId}";var a=e.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a)}catch(t){}}window.addEventListener("WebComponentsReady",function(){_loadHatchScripts("https://www.usehatchapp.com/hubfs/static/js/hatchChat-beta.js")}),"attachShadow"in Element.prototype?document.dispatchEvent(new CustomEvent("WebComponentsReady",{bubbles:!0})):_loadHatchScripts("https://unpkg.com/@webcomponents/webcomponentsjs@2.2.10/webcomponents-bundle.js");
				`}
			</Script>
			<style
				id='quiq-chat-id'
				dangerouslySetInnerHTML={{ __html: `.quiq-floating-element {display:none !important}` }}
			/>
		</>
	);
};
